import { TrainingAndSupport } from '@/components/pages/my-profile/TrainingSupport';
import { FC } from 'react';

export const MyProfileTrainingSupport: FC = () => {
  return <TrainingAndSupport />;
};

export default MyProfileTrainingSupport;
